// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_ST_Internal = require("../Control.Monad.ST.Internal/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Array_ST = require("../Data.Array.ST/index.js");
var Data_FoldableWithIndex = require("../Data.FoldableWithIndex/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_List_Lazy_Types = require("../Data.List.Lazy.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Random_Gen = require("../Random.Gen/index.js");
var makePermutation = function (n) {
    var $3 = n === 0;
    if ($3) {
        return Control_Applicative.pure(Random_Gen.applicativeRandom)(Data_Monoid.mempty(Data_List_Lazy_Types.monoidList));
    };
    return Control_Apply.apply(Random_Gen.applyRandom)(Data_Functor.map(Random_Gen.functorRandom)(Data_List_Lazy_Types.cons)(Random_Gen.intRange(0)(n - 1 | 0)))(makePermutation(n - 1 | 0));
};
var shuffle = function (array) {
    var swap = function (dictPartial) {
        return function (i) {
            return function (j) {
                return function (arr) {
                    return function __do() {
                        var i_ = Data_Functor.map(Control_Monad_ST_Internal.functorST)(Data_Maybe.fromJust())(Data_Array_ST.peek(i)(arr))();
                        var j_ = Data_Functor.map(Control_Monad_ST_Internal.functorST)(Data_Maybe.fromJust())(Data_Array_ST.peek(j)(arr))();
                        Data_Functor["void"](Control_Monad_ST_Internal.functorST)(Data_Array_ST.poke(i)(j_)(arr))();
                        return Data_Functor["void"](Control_Monad_ST_Internal.functorST)(Data_Array_ST.poke(j)(i_)(arr))();
                    };
                };
            };
        };
    };
    var shuffleHelper = function (dictPartial) {
        return function (permutation) {
            return function (arr) {
                return function __do() {
                    Data_FoldableWithIndex.traverseWithIndex_(Control_Monad_ST_Internal.applicativeST)(Data_List_Lazy_Types.foldableWithIndexList)(function (i) {
                        return function (p) {
                            return swap()(i)(i + p | 0)(arr);
                        };
                    })(permutation)();
                    return Data_Array_ST.unsafeFreeze(arr)();
                };
            };
        };
    };
    return (function (dictPartial) {
        var n = Data_Array.length(array);
        return Control_Bind.bind(Random_Gen.bindRandom)(makePermutation(n))(function (p) {
            return Control_Applicative.pure(Random_Gen.applicativeRandom)(Data_Array_ST.withArray(shuffleHelper()(p))(array)());
        });
    })();
};
module.exports = {
    shuffle: shuffle,
    makePermutation: makePermutation
};
